(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3715],{

/***/ 4549:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[hid]/dining/reservation",
      function () {
        return __webpack_require__(5373);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ InputVoucher; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7294);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(155);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7239);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_6__);







function InputVoucher(param) {
    var isValid = param.isValid, codePromo = param.codePromo, selectedResto = param.selectedResto;
    var handleCheckCoupon = function handleCheckCoupon(coupon) {
        if (couponValue == "") return;
        codePromo(coupon);
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_5__/* .postCheckCoupon */ .w1)({
            code: (0,lodash__WEBPACK_IMPORTED_MODULE_6__.lowerCase)(coupon),
            resto: selectedResto
        }).then(function(res) {
            isValid(res.data);
        });
    };
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(""), couponValue = ref[0], setCouponValue = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Flex */ .kCb, {
        w: "full",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Tooltip */ .ua7, {
                label: locale == "id" ? "Tekan Enter setelah mengetik Kupon" : "Press Enter after type the Coupon",
                "aria-label": "A tooltip",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Input */ .IIB, {
                    type: "text",
                    py: 6,
                    placeholder: locale == "id" ? "MASUKKAN KODE PROMO" : "INSERT PROMO CODE",
                    color: "black",
                    borderRadius: 0,
                    textAlign: "center",
                    textTransform: "uppercase",
                    _placeholder: {
                        textTransform: "uppercase"
                    },
                    onChange: function(e) {
                        setCouponValue(e.target.value);
                    },
                    onKeyDown: function(e) {
                        if (e.key == "Enter") {
                            handleCheckCoupon(e.currentTarget.value);
                        }
                    }
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Button */ .zxk, {
                variant: "solid",
                h: "100%",
                bg: "black",
                color: "white",
                onClick: function() {
                    return handleCheckCoupon(couponValue);
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_4__/* .IoChevronForwardOutline */ .nQU, {
                    size: 26
                })
            })
        ]
    });
};


/***/ }),

/***/ 9296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ItemNotFound; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8029);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



function ItemNotFound() {
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)().locale;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Center */ .M5Y, {
        h: "50vh",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Text */ .xvT, {
            children: locale == "id" ? "Tidak Ditemukan." : "Not Found."
        })
    });
};


/***/ }),

/***/ 5373:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Reservation; }
/* harmony export */ });
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4051);
/* harmony import */ var _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8029);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var formik__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2175);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(7294);
/* harmony import */ var react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4853);
/* harmony import */ var react_icons_io5__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(155);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3955);
/* harmony import */ var react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(react_image_lightbox_style_css__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var yup__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(7258);
/* harmony import */ var _components_ItemNotFound__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(9296);
/* harmony import */ var _components_LoadingSpinner__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8506);
/* harmony import */ var _containers_Helmet__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9536);
/* harmony import */ var _layout_FooterHotel__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(8078);
/* harmony import */ var _layout_HeaderV3__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(4850);
/* harmony import */ var _layout_Section__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(1914);
/* harmony import */ var _utils_api__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(7239);
/* harmony import */ var _utils_const__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(3026);
/* harmony import */ var _utils_functions__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(9735);
/* harmony import */ var _utils_hooks__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(1127);
/* harmony import */ var _utils_mediaQuery__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(9741);
/* harmony import */ var _components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(5819);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw1, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw1);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _throw(e) {
    throw e;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
























var __N_SSG = true;
function Reservation(param1) {
    var header = param1.header, hotelBrands = param1.hotelBrands, hero = param1.hero;
    var setCustomerNotes = function setCustomerNotes(param) {
        var date = param.date, time = param.time, type = param.type;
        var textCustomerNote = message ? "Note = ".concat(message, ", \n    Reserved Date = <b>").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .getFormattedDateValue */ .ww)(date), " T ").concat(time, "</b> ") : "Reserved Date = <b>".concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .getFormattedDateValue */ .ww)(date), " T ").concat(time, "</b> ");
        textCustomerNote = isVoucherValid1 && isVoucherValid1.isUsable ? textCustomerNote + ",\n Promo Code = <b>".concat(String(voucher1).toUpperCase(), "</b> ") : textCustomerNote;
        textCustomerNote = type === "PAID" ? textCustomerNote + ",\n Paid by <b>Payment Gateway</b>" : textCustomerNote;
        return textCustomerNote;
    };
    var ref26 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), isVoucherValid1 = ref26[0], setIsVoucherValid = ref26[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), voucher1 = ref1[0], setVoucher = ref1[1];
    var ref2 = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)(), push = ref2.push, locale = ref2.locale, query = ref2.query, reload = ref2.reload, isReady = ref2.isReady;
    var color_primary = header.color_primary, slug = header.slug, id = header.id, location = header.location, phone1 = header.phone, logo_light = header.logo_light, name1 = header.name;
    var ref3 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useFetchSWRv2 */ .bX)("dining", {
        cct_status: "publish",
        hotel_name: name1
    }), 2), diningList = ref3[0], isDiningListLoading = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(0), selectedResto = ref4[0], setSelectedResto = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), selectedRestoName = ref5[0], setSelectedRestoName = ref5[1];
    var handleSelectRestoChange = function(value) {
        setSelectedRestoName(diningList[value].name + "-" + diningList[value].hotel_name);
        setIsVoucherValid(false);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!diningList || isDiningListLoading) return;
        setSelectedResto(0);
        setSelectedRestoName(diningList[0].name + "-" + diningList[0].hotel_name);
        if (query.selected) {
            var idx = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.findIndex)(diningList, function(o) {
                return o._ID == query.selected;
            }, 0);
            if (idx > 0) {
                setSelectedResto(idx);
                setSelectedRestoName(diningList[idx].name + "-" + diningList[idx].hotel_name);
            }
        }
    }, [
        isReady,
        diningList
    ]);
    var ref6 = (0,_utils_mediaQuery__WEBPACK_IMPORTED_MODULE_22__/* .useLargeQuery */ .fc)(), isXLarge = ref6.isXLarge, isLarge = ref6.isLarge;
    var ref7 = _slicedToArray((0,_utils_hooks__WEBPACK_IMPORTED_MODULE_21__/* .useSWRGraphQL */ .f4)('query p_card {\n      products(where: {search: "'.concat(diningList ? diningList[selectedResto].name : "", " ").concat(name1, '", tagIn: "Reservation"}) {\n        nodes {\n          id\n          databaseId\n          slug\n          image {\n            id\n            altText\n            sourceUrl\n          }\n          name\n          ... on VariableProduct {\n            price(format: RAW)\n            regularPrice(format: RAW)\n            id\n            databaseId\n            sku\n            variations {\n              nodes {\n                id\n                databaseId\n                name\n                sku\n                price\n                regularPrice\n                description\n                dateOnSaleTo\n              }\n            }\n          }\n        }\n      }\n  }')), 3), products = ref7[0], isLoading = ref7[1], isError = ref7[2];
    var ref8 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(""), capKey = ref8[0], setCapKey = ref8[1];
    var ref9 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), isCapValid = ref9[0], setIsCapValid = ref9[1];
    var ref10 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), prices = ref10[0], setPrices = ref10[1];
    var ref11 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), adultCount = ref11[0], setAdultCount = ref11[1];
    var ref12 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), childCount = ref12[0], setChildCount = ref12[1];
    var ref13 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), totalCount = ref13[0], setTotalCount = ref13[1];
    var ref14 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), adultSubtotals = ref14[0], setAdultSubtotals = ref14[1];
    var ref15 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), childSubtotals = ref15[0], setChildSubtotals = ref15[1];
    var ref16 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)({
        subTotal: null,
        grandTotal: null
    }), total = ref16[0], setTotal = ref16[1];
    var ref17 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), selectedDate = ref17[0], setSelectedDate = ref17[1];
    var ref18 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), selectedTime = ref18[0], setSelectedTime = ref18[1];
    var ref19 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(), message = ref19[0], setMessage = ref19[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (products && products.products.nodes.length > 0) {
            var tempPrices = products.products.nodes[0].variations.nodes.map(function(param) {
                var price = param.price;
                return price.replace(/\./g, "").replace("Rp", "");
            });
            setPrices(tempPrices);
        }
    }, [
        products
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (prices.length > 0) {
            var temp = [];
            for(var i = 0; i < prices.length; i++){
                temp[i] = 0;
            }
            setAdultCount(_toConsumableArray(temp));
            setChildCount(_toConsumableArray(temp));
            setAdultSubtotals(_toConsumableArray(temp));
            setChildSubtotals(_toConsumableArray(temp));
        }
    }, [
        prices
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (diningList && diningList.length > 0) {
            var temp = 0;
            if (adultSubtotals.length > 0) {
                temp += (0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(adultSubtotals);
            }
            if (childSubtotals.length > 0) {
                temp += (0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(childSubtotals);
            }
            var totDiscount = 0;
            if (isVoucherValid1 != undefined) {
                if (isVoucherValid1 && isVoucherValid1.isUsable) {
                    var tempDisc = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(isVoucherValid1.amount.replace(".00", ""));
                    if (isVoucherValid1.discount_type == "percent") {
                        totDiscount = temp * (tempDisc / 100);
                    } else {
                        totDiscount = temp - tempDisc > 0 ? tempDisc : temp;
                    }
                }
            }
            var ref, ref24, ref25;
            setTotal({
                subTotal: temp,
                grandTotal: temp + ((ref = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(diningList[selectedResto].service_price)) !== null && ref !== void 0 ? ref : 0) + ((ref24 = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(diningList[selectedResto].reservation_fee)) !== null && ref24 !== void 0 ? ref24 : 0) + ((ref25 = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(diningList[selectedResto].tax_price)) !== null && ref25 !== void 0 ? ref25 : 0) - totDiscount
            });
        }
    }, [
        adultSubtotals,
        childSubtotals,
        isVoucherValid1
    ]);
    var ref20 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)([]), selectedMenus = ref20[0], setSelectedMenus = ref20[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        var temp = [];
        temp = adultCount.map(function(value, index) {
            return value + childCount[index];
        });
        setTotalCount(temp);
    }, [
        adultCount,
        childCount
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        (0,_utils_api__WEBPACK_IMPORTED_MODULE_18__/* .postCapthca */ .ay)({
            response: capKey
        }).then(function(res) {
            res.data.success == true ? setIsCapValid(true) : setIsCapValid(false);
        });
    }, [
        capKey
    ]);
    var ref21 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), checkbox = ref21[0], setCheckbox = ref21[1];
    var formik = (0,formik__WEBPACK_IMPORTED_MODULE_5__/* .useFormik */ .TA)({
        initialValues: {
            title: "mr",
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            date: "",
            time: ""
        },
        validationSchema: yup__WEBPACK_IMPORTED_MODULE_11__/* .object */ .Ry({
            title: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            date: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            time: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            firstName: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            lastName: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().required(locale == "id" ? "Harus diisi" : "Required"),
            email: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().email(locale == "id" ? "Email tidak valid" : "Please enter a valid email").required(locale == "id" ? "Harus diisi" : "Required"),
            phone: yup__WEBPACK_IMPORTED_MODULE_11__/* .string */ .Z_().matches(_utils_const__WEBPACK_IMPORTED_MODULE_19__/* .phoneRegExp */ .Oj, locale == "id" ? "Nomor telepon tidak valid" : "Phone must be a valid phone number").required(locale == "id" ? "Harus diisi" : "Required")
        }),
        onSubmit: function(_$param, param) {
            var _$param = _$param !== null ? _$param : _throw(new TypeError("Cannot destructure undefined")), setSubmitting = param.setSubmitting, setStatus = param.setStatus;
        }
    });
    function handleClick() {
        return _handleClick.apply(this, arguments);
    }
    function _handleClick() {
        _handleClick = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var _values, email, date, firstName, lastName, title, phone, time, customerNote;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formik.setSubmitting(true);
                        _values = formik.values, email = _values.email, date = _values.date, firstName = _values.firstName, lastName = _values.lastName, title = _values.title, phone = _values.phone, time = _values.time;
                        if (!(adultSubtotals.length == 0 && childSubtotals.length == 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        setShowPop(true);
                        setPopText("Please choose product...");
                        formik.setSubmitting(false);
                        return _ctx.abrupt("return");
                    case 9:
                        customerNote = setCustomerNotes({
                            date: date,
                            time: time,
                            type: "PAID"
                        });
                        _ctx.next = 12;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_18__/* .postOrder */ .mv)({
                            name: firstName + " " + lastName,
                            email: email,
                            phone: phone,
                            city: "Indonesia",
                            country: "Indonesia",
                            street: "Indonesia",
                            price: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toString)(total.grandTotal),
                            items: totalCount.map(function(v, i) {
                                var ref, ref27, ref28;
                                var variation_id = (ref27 = products === null || products === void 0 ? void 0 : (ref = products.products) === null || ref === void 0 ? void 0 : ref.nodes[0].variations) === null || ref27 === void 0 ? void 0 : ref27.nodes[i].databaseId;
                                var product_id = products === null || products === void 0 ? void 0 : (ref28 = products.products) === null || ref28 === void 0 ? void 0 : ref28.nodes[0].databaseId;
                                return {
                                    product_id: product_id,
                                    quantity: v !== null && v !== void 0 ? v : 0,
                                    variation_id: variation_id
                                };
                            }),
                            message: "total adults = ".concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(adultCount), ", total children = ").concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(childCount), ", special message = ").concat(message, ", Reserved Date = ").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .getFormattedDateValue */ .ww)(date), " T ").concat(time),
                            type: "".concat(query.hid, "/dining/reservation"),
                            customer_note: customerNote,
                            slug: query.hid,
                            coupon: isVoucherValid1 && isVoucherValid1.isUsable ? voucher1 : ""
                        }).then(function(res) {
                            res.status == 200 && formik.setStatus("success");
                            // setShowPop(true); //COD
                            window.open(res.data.redirect_url, "_self"); //RDP PAYMENT
                        }).catch(function(error) {
                            setShowPop(true);
                            setPopText("Error!!! Please Check The Data Input...");
                        });
                    case 12:
                        formik.setSubmitting(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleClick.apply(this, arguments);
    }
    function handleClickCod() {
        return _handleClickCod.apply(this, arguments);
    }
    function _handleClickCod() {
        _handleClickCod = _asyncToGenerator(_var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var _values, email, date, firstName, lastName, title, phone, time, customerNoteCod;
            return _var_www_vhosts_parador_hotels_com_httpdocs_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (formik.isValid) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        formik.setSubmitting(true);
                        _values = formik.values, email = _values.email, date = _values.date, firstName = _values.firstName, lastName = _values.lastName, title = _values.title, phone = _values.phone, time = _values.time;
                        if (!((0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(adultCount) == 0 && (0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(childCount) == 0)) {
                            _ctx.next = 9;
                            break;
                        }
                        setShowPop(true);
                        setPopText("Please choose product...");
                        formik.setSubmitting(false);
                        return _ctx.abrupt("return");
                    case 9:
                        customerNoteCod = setCustomerNotes({
                            date: date,
                            time: time,
                            type: "UNPAID"
                        });
                        _ctx.next = 12;
                        return (0,_utils_api__WEBPACK_IMPORTED_MODULE_18__/* .postOrder */ .mv)({
                            name: firstName + " " + lastName,
                            email: email,
                            phone: phone,
                            city: "Indonesia",
                            country: "Indonesia",
                            street: "Indonesia",
                            price: (0,lodash__WEBPACK_IMPORTED_MODULE_3__.toString)(total.grandTotal),
                            payment: "cod",
                            items: totalCount.map(function(v, i) {
                                var ref, ref29, ref30;
                                var variation_id = (ref29 = products === null || products === void 0 ? void 0 : (ref = products.products) === null || ref === void 0 ? void 0 : ref.nodes[0].variations) === null || ref29 === void 0 ? void 0 : ref29.nodes[i].databaseId;
                                var product_id = products === null || products === void 0 ? void 0 : (ref30 = products.products) === null || ref30 === void 0 ? void 0 : ref30.nodes[0].databaseId;
                                return {
                                    product_id: product_id,
                                    quantity: v !== null && v !== void 0 ? v : 0,
                                    variation_id: variation_id
                                };
                            }),
                            message: "total adults = ".concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(adultCount), ", total children = ").concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.sum)(childCount), ", special message = ").concat(message, ", <strong>Reserved Date = ").concat((0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .getFormattedDateValue */ .ww)(date), " T ").concat(time, "</strong>"),
                            // type: ``,
                            type: "".concat(query.hid, "/dining/reservation"),
                            customer_note: customerNoteCod,
                            coupon: isVoucherValid1 && isVoucherValid1.isUsable ? voucher1 : ""
                        }).then(function(res) {
                            res.status == 200 && formik.setStatus("success");
                            setShowPop(true); //COD
                            setPopText("Thank you for purchasing, please check your email for further details");
                            // formik.resetForm();
                            formik.setValues(_objectSpread({}, formik.values, {
                                firstName: "",
                                lastName: "",
                                email: "",
                                phone: ""
                            }));
                            setIsVoucherValid(false);
                            setCheckbox(false);
                        // window.open(res.data.redirect_url, "_self"); //RDP PAYMENT
                        }).catch(function(error) {
                            setShowPop(true);
                            setPopText("Error!!! Please Check The Data Input...");
                        });
                    case 12:
                        formik.setSubmitting(false);
                    case 13:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _handleClickCod.apply(this, arguments);
    }
    var ref22 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)(false), showPop = ref22[0], setShowPop = ref22[1];
    var ref23 = (0,react__WEBPACK_IMPORTED_MODULE_6__.useState)("Thank you for purchasing, please check your email for further details"), popText = ref23[0], setPopText = ref23[1];
    (0,react__WEBPACK_IMPORTED_MODULE_6__.useEffect)(function() {
        if (!isReady) return;
        if (query.proccess == "success" || query.transaction_id) {
            if (!query.sig) return;
            formik.setSubmitting(true);
            setShowPop(true);
            (0,_utils_api__WEBPACK_IMPORTED_MODULE_18__/* .getOneOrder */ .Ne)({
                id: query.transaction_id,
                total: query.total,
                slug: query.hid
            }).then(function(res) {
                if (res.data.response_code == 0) {
                    // ! this coding add because RDP not POST API order-rdp
                    (0,_utils_api__WEBPACK_IMPORTED_MODULE_18__/* .postRDPnotify */ .D0)(res.data).catch(function(error) {
                        setPopText("Payment Failed. Please Try Again");
                    });
                } else if (res.data.response_code == -1) {
                    setPopText("Payment Failed. Please Try Again");
                } else {
                    setPopText("Payment Failed. Please Try Again");
                }
                formik.setSubmitting(false);
                setInterval(function() {
                    window.open("/".concat(query.hid, "/dining/reservation"), "_self");
                }, 7000);
            });
        }
    }, [
        isReady
    ]);
    var _NEXT_PUBLIC_CAPTCHA_SITE_KEY, _NEXT_PUBLIC_CAPTCHA_SITE_KEY1;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_containers_Helmet__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                title: "Dining Reservation | ".concat((0,lodash__WEBPACK_IMPORTED_MODULE_3__.capitalize)(name1), " | Parador Hotels & Resorts")
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_HeaderV3__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                headerItem: header,
                isHomepage: false,
                hotelBrands: hotelBrands
            }),
            (showPop || formik.isSubmitting) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                position: "fixed",
                top: 0,
                zIndex: 5,
                bg: "blackAlpha.600",
                h: "100vh",
                w: "100vw",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .AbsoluteCenter */ .umj, {
                    w: [
                        "90vw",
                        "70vw",
                        "50vw"
                    ],
                    h: [
                        "60vh",
                        "50vh",
                        "40vh"
                    ],
                    bg: "black",
                    px: 20,
                    borderColor: "white",
                    borderRadius: 0,
                    borderWidth: 10,
                    zIndex: 6,
                    children: formik.isSubmitting ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        gap: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Spinner */ .$jN, {
                            color: "white",
                            size: "xl"
                        })
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                        w: "100%",
                        h: "100%",
                        flexDir: "column",
                        gap: 10,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                as: "h3",
                                fontWeight: 400,
                                letterSpacing: "widest",
                                fontSize: "xl",
                                textAlign: "center",
                                color: "white",
                                children: popText
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                    variant: "outline",
                                    color: "white",
                                    _hover: {
                                        opacity: 0.8
                                    },
                                    onClick: function() {
                                        setShowPop(false);
                                    },
                                    children: "CLOSE"
                                })
                            })
                        ]
                    })
                })
            }),
            isDiningListLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingSpinner__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_layout_Section__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                            mb: 2,
                            as: "h1",
                            fontWeight: 400,
                            letterSpacing: "wider",
                            textAlign: "center",
                            children: locale == "id" ? "RESERVASI RESTORAN" : "DINING RESERVATION"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                        gap: 2,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                flex: 1
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                flex: 8,
                                flexDir: "column",
                                gap: 6,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                mb: 6,
                                                as: "h2",
                                                fontWeight: 400,
                                                letterSpacing: "wider",
                                                fontSize: "2xl",
                                                children: locale == "id" ? "INFORMASI KONTAK" : "CONTACT INFORMATION"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: [
                                                    0,
                                                    0,
                                                    0,
                                                    6
                                                ],
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "20%"
                                                        ],
                                                        flexDir: "column",
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "title",
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Gelar*" : "Title*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                                        fontSize: "sm",
                                                                        id: "title",
                                                                        name: "title",
                                                                        borderRadius: 0,
                                                                        _focus: {},
                                                                        onChange: function(e) {
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                title: e.target.value
                                                                            }));
                                                                        },
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                                value: "mr",
                                                                                children: locale == "id" ? "Bapak" : "Mr"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                                value: "mrs",
                                                                                children: locale == "id" ? "Ibu" : "Mrs"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.title
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "30%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "firstName",
                                                                fontSize: "md",
                                                                whiteSpace: "nowrap",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Nama Depan*" : "First Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "firstName",
                                                                        name: "firstName",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Nama Depan" : "First Name",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.firstName
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.firstName
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "30%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "lastName",
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                whiteSpace: "nowrap",
                                                                children: locale == "id" ? "Nama Belakang*" : "Last Name*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "lastName",
                                                                        name: "lastName",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Nama Belakang" : "Last Name",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.lastName
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.lastName
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "40%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "email",
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: "Email*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "email",
                                                                        name: "email",
                                                                        type: "text",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Email" : "Your email",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.email
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.email
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "40%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "phone",
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Telepon*" : "phone*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "phone",
                                                                        name: "phone",
                                                                        type: "tel",
                                                                        borderRadius: 0,
                                                                        placeholder: "123456",
                                                                        onChange: formik.handleChange,
                                                                        onBlur: formik.handleBlur,
                                                                        value: formik.values.phone
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.phone
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    isLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_LoadingSpinner__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {}) : diningList.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ItemNotFound__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                        letterSpacing: "wide",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                mb: 6,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                    orientation: "horizontal"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                mb: 6,
                                                as: "h2",
                                                fontWeight: 400,
                                                letterSpacing: "wider",
                                                fontSize: "2xl",
                                                children: locale == "id" ? "KELOLA RESERVASI" : "MANAGE RESERVATION"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                gap: [
                                                    0,
                                                    0,
                                                    0,
                                                    6
                                                ],
                                                flexDir: [
                                                    "column",
                                                    null,
                                                    null,
                                                    "row"
                                                ],
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "50%"
                                                        ],
                                                        flexDir: "column",
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Restoran*" : "RESTAURANT*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Select */ .PhF, {
                                                                    fontSize: "sm",
                                                                    borderRadius: 0,
                                                                    _focus: {},
                                                                    onChange: function(e) {
                                                                        setSelectedResto((0,lodash__WEBPACK_IMPORTED_MODULE_3__.toNumber)(e.target.value));
                                                                        handleSelectRestoChange(e.target.value);
                                                                    },
                                                                    value: selectedResto,
                                                                    children: diningList.map(function(param, i) {
                                                                        var name = param.name;
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("option", {
                                                                            value: i,
                                                                            children: name
                                                                        }, name);
                                                                    })
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "date",
                                                                fontSize: "md",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Tanggal*" : "Date*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                    fontSize: "sm",
                                                                    id: "date",
                                                                    name: "date",
                                                                    min: new Date().toISOString().split("T")[0],
                                                                    type: "date",
                                                                    borderRadius: 0,
                                                                    // defaultValue={new Date().toISOString().split("T")[0]}
                                                                    onChange: function(e) {
                                                                        formik.setValues(_objectSpread({}, formik.values, {
                                                                            date: e.target.value
                                                                        }));
                                                                        setSelectedDate(e.target.value);
                                                                    }
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                fontSize: "xs",
                                                                color: "red.500",
                                                                mt: 1,
                                                                children: formik.errors.date
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                        flexDir: "column",
                                                        w: [
                                                            "full",
                                                            null,
                                                            null,
                                                            "25%"
                                                        ],
                                                        mb: [
                                                            3,
                                                            null,
                                                            null,
                                                            0
                                                        ],
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "phone",
                                                                fontSize: "md",
                                                                noOfLines: 1,
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Waktu tersedia*" : "AVAILABLE TIMES*"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Input */ .IIB, {
                                                                        fontSize: "sm",
                                                                        id: "phone",
                                                                        name: "phone",
                                                                        type: "time",
                                                                        borderRadius: 0,
                                                                        placeholder: "123456",
                                                                        onChange: function(e) {
                                                                            formik.setValues(_objectSpread({}, formik.values, {
                                                                                time: e.target.value
                                                                            }));
                                                                            setSelectedTime(e.target.value);
                                                                        }
                                                                    }),
                                                                    " ",
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                        fontSize: "xs",
                                                                        color: "red.500",
                                                                        mt: 1,
                                                                        children: formik.errors.time
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            products.products.nodes.length < 1 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_ItemNotFound__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {}) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                children: [
                                                    !isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                w: "full",
                                                                my: 4,
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Divider */ .izJ, {
                                                                    orientation: "horizontal"
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Heading */ .X6q, {
                                                                mb: 6,
                                                                as: "h2",
                                                                fontWeight: 400,
                                                                letterSpacing: "wider",
                                                                fontSize: "2xl",
                                                                children: locale == "id" ? "Menu Makan*" : "MEAL MENU*"
                                                            })
                                                        ]
                                                    }),
                                                    isXLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MIq, {
                                                        columns: [
                                                            1,
                                                            2,
                                                            3,
                                                            4
                                                        ],
                                                        bg: "blackAlpha.100",
                                                        mt: 8,
                                                        gap: 6,
                                                        px: 4,
                                                        py: 4,
                                                        className: "label-default",
                                                        borderTop: "1px solid var(--chakra-colors-blackAlpha-600)",
                                                        borderBottom: "1px solid var(--chakra-colors-blackAlpha-200)",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                noOfLines: 1,
                                                                fontWeight: 400,
                                                                children: locale == "id" ? "Menu Makan*" : "MEAL MENU*"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                display: [
                                                                    "none",
                                                                    null,
                                                                    "unset"
                                                                ],
                                                                noOfLines: 1,
                                                                children: locale == "id" ? "Dewasa*" : "ADULTS*"
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                htmlFor: "title",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                display: [
                                                                    "none",
                                                                    null,
                                                                    "unset"
                                                                ],
                                                                children: [
                                                                    locale == "id" ? "Anak" : "CHILDREN",
                                                                    " (5 - 11)"
                                                                ]
                                                            }),
                                                            " ",
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                textAlign: "right",
                                                                htmlFor: "title",
                                                                fontSize: "xl",
                                                                textTransform: "uppercase",
                                                                fontWeight: 400,
                                                                children: "SUBTOTAL"
                                                            })
                                                        ]
                                                    }),
                                                    products.products.nodes[0].variations.nodes.map(function(param, i) {
                                                        var name = param.name, description = param.description, sku = param.sku, dateOnSaleTo = param.dateOnSaleTo;
                                                        var showName = (0,lodash__WEBPACK_IMPORTED_MODULE_3__.lowerCase)(name).replace((0,lodash__WEBPACK_IMPORTED_MODULE_3__.lowerCase)(header.name), "").replace((0,lodash__WEBPACK_IMPORTED_MODULE_3__.lowerCase)(diningList[selectedResto].name), "");
                                                        if (dateOnSaleTo != null && new Date(dateOnSaleTo) <= new Date()) return null;
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MIq, {
                                                            columns: [
                                                                1,
                                                                null,
                                                                3,
                                                                4
                                                            ],
                                                            gap: 6,
                                                            px: 3,
                                                            py: 4,
                                                            className: "label-default",
                                                            borderBottom: "1px solid var(--chakra-colors-blackAlpha-200)",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                    flexDir: "column",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "md",
                                                                            textTransform: "capitalize",
                                                                            fontWeight: 500,
                                                                            children: showName
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "sm",
                                                                            textTransform: "capitalize",
                                                                            fontWeight: 400,
                                                                            color: "blackAlpha.600",
                                                                            children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(prices[i])
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "sm",
                                                                            textTransform: "capitalize",
                                                                            fontWeight: 400,
                                                                            children: description
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                    justify: "space-between",
                                                                    align: "center",
                                                                    w: "full",
                                                                    p: 2,
                                                                    borderColor: "gray.300",
                                                                    color: "gray.600",
                                                                    borderWidth: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                            cursor: adultCount[i] > 0 ? "pointer" : "not-allowed",
                                                                            color: adultCount[i] > 0 ? "gray.600" : "gray.300",
                                                                            onClick: function() {
                                                                                var tempCount = _toConsumableArray(adultCount), tempSubtotal = _toConsumableArray(adultSubtotals);
                                                                                if (adultCount[i] > 0) {
                                                                                    tempCount[i]--;
                                                                                    tempSubtotal[i] = prices[i] * tempCount[i];
                                                                                    setAdultSubtotals(_toConsumableArray(tempSubtotal));
                                                                                }
                                                                                setAdultCount(_toConsumableArray(tempCount));
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoRemoveSharp */ .PS1, {
                                                                                size: 24
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "md",
                                                                            as: "span",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                                    children: adultCount[i]
                                                                                }),
                                                                                " ",
                                                                                locale == "id" ? "Dewasa" : "Adult"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                            cursor: adultCount[i] < 99 ? "pointer" : "not-allowed",
                                                                            color: adultCount[i] < 99 ? "gray.600" : "gray.300",
                                                                            onClick: function() {
                                                                                var tempCount = _toConsumableArray(adultCount), tempSubtotal = _toConsumableArray(adultSubtotals);
                                                                                if (adultCount[i] < 99) {
                                                                                    tempCount[i]++;
                                                                                    tempSubtotal[i] = prices[i] * tempCount[i];
                                                                                    setAdultSubtotals(_toConsumableArray(tempSubtotal));
                                                                                }
                                                                                setAdultCount(_toConsumableArray(tempCount));
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoAddSharp */ .Z2A, {
                                                                                size: 24
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                    justify: "space-between",
                                                                    align: "center",
                                                                    w: "full",
                                                                    p: 2,
                                                                    borderColor: "gray.300",
                                                                    color: "gray.600",
                                                                    borderWidth: 1,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                            cursor: childCount[i] > 0 ? "pointer" : "not-allowed",
                                                                            color: childCount[i] > 0 ? "gray.600" : "gray.300",
                                                                            onClick: function() {
                                                                                var tempCount = _toConsumableArray(childCount), tempSubtotal = _toConsumableArray(childSubtotals);
                                                                                if (childCount[i] > 0) {
                                                                                    tempCount[i]--;
                                                                                    tempSubtotal[i] = prices[i] * tempCount[i];
                                                                                    setChildSubtotals(_toConsumableArray(tempSubtotal));
                                                                                }
                                                                                setChildCount(_toConsumableArray(tempCount));
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoRemoveSharp */ .PS1, {
                                                                                size: 24
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "md",
                                                                            as: "span",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("strong", {
                                                                                    children: childCount[i]
                                                                                }),
                                                                                " ",
                                                                                locale == "id" ? "Anak" : "Child"
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                            cursor: childCount[i] < 99 ? "pointer" : "not-allowed",
                                                                            color: childCount[i] < 99 ? "gray.600" : "gray.300",
                                                                            onClick: function() {
                                                                                var tempCount = _toConsumableArray(childCount), tempSubtotal = _toConsumableArray(childSubtotals);
                                                                                if (childCount[i] < 99) {
                                                                                    tempCount[i]++;
                                                                                    tempSubtotal[i] = prices[i] * tempCount[i];
                                                                                    setChildSubtotals(_toConsumableArray(tempSubtotal));
                                                                                }
                                                                                setChildCount(_toConsumableArray(tempCount));
                                                                            },
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_icons_io5__WEBPACK_IMPORTED_MODULE_8__/* .IoAddSharp */ .Z2A, {
                                                                                size: 24
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "md",
                                                                    textTransform: "capitalize",
                                                                    fontWeight: 500,
                                                                    textAlign: {
                                                                        base: "left",
                                                                        lg: "right"
                                                                    },
                                                                    children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(childSubtotals[i] + adultSubtotals[i])
                                                                })
                                                            ]
                                                        }, name);
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MIq, {
                                                        columns: [
                                                            1,
                                                            1,
                                                            2
                                                        ],
                                                        mt: 2,
                                                        gap: 6,
                                                        pr: 3,
                                                        py: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                        htmlFor: "title",
                                                                        fontSize: "xl",
                                                                        textTransform: "uppercase",
                                                                        fontWeight: 400,
                                                                        children: locale == "id" ? "Permintaan Spesial" : "SPECIAL REQUEST"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Textarea */ .gxH, {
                                                                        fontSize: "sm",
                                                                        id: "message",
                                                                        name: "message",
                                                                        borderRadius: 0,
                                                                        placeholder: locale == "id" ? "Permintaan Kamu" : "Your Request",
                                                                        onChange: function(e) {
                                                                            setMessage(e.target.value);
                                                                        }
                                                                    }),
                                                                    isLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZJ, {
                                                                                mt: 4,
                                                                                mb: 6,
                                                                                defaultChecked: false,
                                                                                isChecked: checkbox,
                                                                                onChange: function() {
                                                                                    setCheckbox(!checkbox);
                                                                                },
                                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                    fontSize: "xs",
                                                                                    children: [
                                                                                        locale == "id" ? "Saya telah membaca dan menyetujui" : "I have read and accepted the",
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                                            onClick: function() {
                                                                                                push("/privacy-policy");
                                                                                            },
                                                                                            style: {
                                                                                                fontWeight: 500,
                                                                                                textDecoration: "underline"
                                                                                            },
                                                                                            children: locale == "id" ? "Privasi & Kebijakan" : "privacy policy"
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                                sitekey: (_NEXT_PUBLIC_CAPTCHA_SITE_KEY = "6LffTCkgAAAAAOh8Ko1Zx6016qXUseJu2gwQECFl") !== null && _NEXT_PUBLIC_CAPTCHA_SITE_KEY !== void 0 ? _NEXT_PUBLIC_CAPTCHA_SITE_KEY : "",
                                                                                onChange: function(value) {
                                                                                    return setCapKey(value);
                                                                                }
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                flexDir: "column",
                                                                gap: 3,
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                        justify: "space-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                fontSize: "xl",
                                                                                textTransform: "uppercase",
                                                                                fontWeight: 400,
                                                                                children: "SUBTOTAL"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                fontSize: "md",
                                                                                textTransform: "capitalize",
                                                                                fontWeight: 400,
                                                                                textAlign: "right",
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(total.subTotal)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                        justify: "space-between",
                                                                        borderBottom: "1px solid var(--chakra-colors-blackAlpha-100)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                fontSize: "sm",
                                                                                fontWeight: 400,
                                                                                children: locale == "id" ? "Biaya Reservasi" : "Reservation Fee"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                fontSize: "sm",
                                                                                textTransform: "capitalize",
                                                                                fontWeight: 400,
                                                                                textAlign: "right",
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(diningList[selectedResto].reservation_fee)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                        justify: "space-between",
                                                                        borderBottom: "1px solid var(--chakra-colors-blackAlpha-100)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                fontSize: "sm",
                                                                                fontWeight: 400,
                                                                                children: locale == "id" ? "Pajak" : "Tax"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                fontSize: "sm",
                                                                                textTransform: "capitalize",
                                                                                fontWeight: 400,
                                                                                textAlign: "right",
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(diningList[selectedResto].tax_price)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                        justify: "space-between",
                                                                        borderBottom: isVoucherValid1 && isVoucherValid1.isUsable ? "1px solid var(--chakra-colors-blackAlpha-100)" : "1px solid var(--chakra-colors-blackAlpha-500)",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                fontSize: "sm",
                                                                                fontWeight: 400,
                                                                                children: locale == "id" ? "Biaya Pelayanan" : "Service"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                fontSize: "sm",
                                                                                textTransform: "capitalize",
                                                                                fontWeight: 400,
                                                                                textAlign: "right",
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(diningList[selectedResto].service_price)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isVoucherValid1 && isVoucherValid1.isUsable && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                            justify: "space-between",
                                                                            borderBottom: "1px solid var(--chakra-colors-blackAlpha-500)",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                    fontSize: "sm",
                                                                                    fontWeight: 400,
                                                                                    children: locale == "id" ? "Diskon" : "Discount"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                    fontSize: "sm",
                                                                                    textTransform: "capitalize",
                                                                                    fontWeight: 400,
                                                                                    textAlign: "right",
                                                                                    children: [
                                                                                        isVoucherValid1.discount_type == "percent" ? isVoucherValid1.amount.replace(".00", "") : (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(isVoucherValid1.amount.replace(".00", "")),
                                                                                        isVoucherValid1.discount_type == "percent" && "%"
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Flex */ .kCb, {
                                                                        justify: "space-between",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .FormLabel */ .lXp, {
                                                                                fontSize: "md",
                                                                                fontWeight: 600,
                                                                                children: locale == "id" ? "Jumlah Akhir" : "Grand Total"
                                                                            }),
                                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                                fontSize: "md",
                                                                                textTransform: "capitalize",
                                                                                fontWeight: 600,
                                                                                textAlign: "right",
                                                                                children: (0,_utils_functions__WEBPACK_IMPORTED_MODULE_20__/* .formatRupiah */ .b7)(total.grandTotal)
                                                                            })
                                                                        ]
                                                                    }),
                                                                    isVoucherValid1 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Center */ .M5Y, {
                                                                        bg: isVoucherValid1.isUsable ? "blackAlpha.600" : "red.400",
                                                                        w: "full",
                                                                        p: 3,
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                            fontSize: "small",
                                                                            fontWeight: 500,
                                                                            textTransform: "uppercase",
                                                                            letterSpacing: "wide",
                                                                            color: "white",
                                                                            children: isVoucherValid1.isUsable ? "".concat(locale == "id" ? "Promo dipakai:" : "Promo used:", " ").concat(voucher1) : locale == "id" ? "Kode promo salah" : "Promo code is invalid"
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_components_Input_InputVoucher__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z, {
                                                                        codePromo: function(voucher) {
                                                                            return setVoucher(voucher);
                                                                        },
                                                                        isValid: function(isVoucherValid) {
                                                                            return setIsVoucherValid(isVoucherValid);
                                                                        },
                                                                        selectedResto: selectedRestoName
                                                                    })
                                                                ]
                                                            })
                                                        ]
                                                    }),
                                                    !isLarge && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Checkbox */ .XZJ, {
                                                                mt: 4,
                                                                mb: 6,
                                                                defaultChecked: false,
                                                                isChecked: checkbox,
                                                                onChange: function() {
                                                                    setCheckbox(!checkbox);
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .xvT, {
                                                                    fontSize: "xs",
                                                                    children: [
                                                                        locale == "id" ? "Saya telah membaca dan menyetujui" : "I have read and accepted the",
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                                                                            onClick: function() {
                                                                                push("/privacy-policy");
                                                                            },
                                                                            style: {
                                                                                fontWeight: 500,
                                                                                textDecoration: "underline"
                                                                            },
                                                                            children: locale == "id" ? "Privasi & Kebijakan" : "privacy policy"
                                                                        })
                                                                    ]
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_google_recaptcha__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                                                                sitekey: (_NEXT_PUBLIC_CAPTCHA_SITE_KEY1 = "6LffTCkgAAAAAOh8Ko1Zx6016qXUseJu2gwQECFl") !== null && _NEXT_PUBLIC_CAPTCHA_SITE_KEY1 !== void 0 ? _NEXT_PUBLIC_CAPTCHA_SITE_KEY1 : "",
                                                                onChange: function(value) {
                                                                    return setCapKey(value);
                                                                }
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .SimpleGrid */ .MIq, {
                                                        columns: [
                                                            1,
                                                            1,
                                                            2
                                                        ],
                                                        mt: 3,
                                                        gap: 6,
                                                        py: 4,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                                size: "md",
                                                                variant: "solid",
                                                                bg: header.color_primary,
                                                                color: "white",
                                                                py: 6,
                                                                cursor: formik.isSubmitting || !formik.isValid || formik.status == "success" ? "not-allowed" : "pointer",
                                                                onClick: handleClick,
                                                                disabled: formik.isSubmitting || !formik.isValid || formik.status == "success" || !isCapValid || (0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(formik.values.firstName) || !total.subTotal || checkbox == false,
                                                                children: locale == "id" ? "PESAN & BAYAR" : "RESERVE & PAY NOW"
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Button */ .zxk, {
                                                                size: "md",
                                                                variant: "outline",
                                                                borderColor: header.color_primary,
                                                                color: header.color_primary,
                                                                py: 6,
                                                                cursor: formik.isSubmitting || !formik.isValid || formik.status == "success" ? "not-allowed" : "pointer",
                                                                onClick: handleClickCod,
                                                                disabled: formik.isSubmitting || !formik.isValid || formik.status == "success" || !isCapValid || (0,lodash__WEBPACK_IMPORTED_MODULE_3__.isEmpty)(formik.values.firstName) || !total.subTotal || checkbox == false,
                                                                children: locale == "id" ? "PESAN" : "RESERVE"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .xuv, {
                                flex: 1
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_layout_FooterHotel__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
                hotelSlug: header.slug,
                instagram: header.instagram,
                facebook: header.facebook,
                locationLink: header.location_url,
                location: header.location_long,
                email: header.email,
                phone: header.phone,
                bg: color_primary,
                color: "white",
                logo: logo_light
            })
        ]
    });
};
function ColoredButton(param) {
    var _type = param.type, type = _type === void 0 ? "outline" : _type, children = param.children, _color = param.color, color = _color === void 0 ? "black" : _color, onClick = param.onClick;
    return /*#__PURE__*/ _jsx(Button, {
        bg: type === "outline" ? "white" : color,
        border: "1.5px solid ".concat(color),
        color: type === "outline" ? color : "white",
        // px={16}
        _hover: {
            bg: color,
            color: "white"
        },
        w: 260,
        py: 4,
        fontWeight: 500,
        children: children
    });
}


/***/ }),

/***/ 7239:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Jp": function() { return /* binding */ getCountryList; },
  "Ne": function() { return /* binding */ getOneOrder; },
  "Jv": function() { return /* binding */ getSigMatch; },
  "Mc": function() { return /* binding */ getSpecialOffer; },
  "oW": function() { return /* binding */ getWPDining; },
  "Mu": function() { return /* binding */ getWPImage; },
  "ts": function() { return /* binding */ postAccount; },
  "ay": function() { return /* binding */ postCapthca; },
  "w1": function() { return /* binding */ postCheckCoupon; },
  "$8": function() { return /* binding */ postMeetingEnquiry; },
  "lB": function() { return /* binding */ postMessages; },
  "mv": function() { return /* binding */ postOrder; },
  "GK": function() { return /* binding */ postOrderLater; },
  "D0": function() { return /* binding */ postRDPnotify; },
  "ZC": function() { return /* binding */ postSendMail; },
  "AQ": function() { return /* binding */ postWeddingEnquiry; }
});

// UNUSED EXPORTS: getBlogDetail, getDining, getFaq, getHotelBrands, getHotelDetail, getHotelNavBrands, getRoomDetail, getSitemap, getSliderSpecialOffer

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./src/utils/functions.js
var functions = __webpack_require__(9735);
;// CONCATENATED MODULE: ./src/utils/apiCache.ts
var cache = new Map();
function getCacheKey(endpoint) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var paramStr = JSON.stringify(params);
    return "".concat(endpoint, ":").concat(paramStr);
}
function getCachedData(key) {
    var entry = cache.get(key);
    if (!entry) return null;
    var now = Date.now();
    var isExpired = now - entry.timestamp > entry.ttl;
    if (isExpired) {
        cache.delete(key);
        return null;
    }
    return entry.data;
}
function setCachedData(key, data) {
    var ttlSeconds = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 3600;
    cache.set(key, {
        data: data,
        timestamp: Date.now(),
        ttl: ttlSeconds * 1000
    });
}
function clearCache() {
    cache.clear();
}
function getCacheStats() {
    return {
        size: cache.size,
        entries: Array.from(cache.keys())
    };
}

;// CONCATENATED MODULE: ./src/utils/api.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



//wordpress endpoint
var getHotelDetail = function(params) {
    return functions/* fetcher.get */._i.get("/hotels/", {
        params: params
    });
};
var getRoomDetail = function(params) {
    return fetcher.get("/rooms/", {
        params: params
    });
};
var getBlogDetail = function(params) {
    return fetcher.get("/blog/", {
        params: params
    });
};
var getSitemap = function(params) {
    return fetcher.get("/sitemap/", {
        params: params
    });
};
var getSpecialOffer = function(params) {
    return functions/* fetcher.get */._i.get("/special_offers/", {
        params: params
    });
};
var getWPDining = function(params) {
    return functions/* fetcher.get */._i.get("/dining/?", {
        params: params
    });
};
var getFaq = function(params) {
    return fetcher.get("/faq/", {
        params: params
    });
};
//nextjs endpoint
var getCountryList = function(params) {
    return functions/* fetcherNext.get */.mj.get("/country-list/?", {
        params: params
    });
};
var getDining = function(params) {
    return fetcherNext.get("/dining-nav/?", {
        params: params
    });
};
var getSliderSpecialOffer = function(params) {
    return fetcherNext.get("/special-offer-slider/?", {
        params: params
    });
};
var getHotelNavBrands = function(params) {
    return fetcherNext.get("/hotel-nav-brands/?", {
        params: params
    });
};
var getHotelBrands = function() {
    var _ref = _asyncToGenerator(runtime_default().mark(function _callee(params) {
        var cacheKey, cached, result;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cacheKey = getCacheKey("getHotelBrands", params);
                    cached = getCachedData(cacheKey);
                    if (!cached) {
                        _ctx.next = 5;
                        break;
                    }
                    ;
                    return _ctx.abrupt("return", cached);
                case 5:
                    ;
                    _ctx.prev = 6;
                    _ctx.next = 9;
                    return Promise.all([
                        getHotelDetail({
                            brand: "Atria Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Atria residences",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Atria residences", r.data);
                        }),
                        getHotelDetail({
                            brand: "Starlet Hotel",
                            _orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Starlet Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Vega Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Vega Hotel", r.data);
                        }),
                        getHotelDetail({
                            brand: "Fame Hotel",
                            orderby: "hotel_location",
                            _order: "asc"
                        }).then(function(r) {
                            return (0,functions/* mappingBrand */.nH)("Fame Hotel", r.data);
                        }), 
                    ]);
                case 9:
                    result = _ctx.sent;
                    // Cache the result for 1 hour
                    setCachedData(cacheKey, result, 3600);
                    return _ctx.abrupt("return", result);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](6);
                    ;
                    throw _ctx.t0;
                case 18:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                6,
                14
            ]
        ]);
    }));
    return function getHotelBrands(params) {
        return _ref.apply(this, arguments);
    };
}();
var postMessages = function(body) {
    return functions/* fetcher.post */._i.post("/messages/", body);
};
var postMeetingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/meeting_enquiry/", body);
};
var postWeddingEnquiry = function(body) {
    return functions/* fetcher.post */._i.post("/wedding_enquiry/", body);
};
var postAccount = function(body) {
    return functions/* fetcher.post */._i.post("/accounts/", body);
};
var postOrder = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-now?user=guest", body);
};
var getSigMatch = function(params) {
    return functions/* fetcherNext.get */.mj.get("/is-paid/?", {
        params: params
    });
};
var getOneOrder = function(params) {
    return functions/* fetcherNext.get */.mj.get("/check-order/?", {
        params: params
    });
};
var postOrderLater = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-later", body);
};
var postRDPnotify = function(body) {
    return functions/* fetcherNext.post */.mj.post("/order-rdp", body);
};
var postCapthca = function(body) {
    return functions/* fetcherNext.post */.mj.post("/captcha", body);
};
var postCheckCoupon = function(body) {
    return functions/* fetcherNext.post */.mj.post("/coupon-check?user=guest", body);
};
var getWPImage = function(id) {
    return functions/* fetcherWPImage.get */.ON.get("/".concat(id));
};
var postSendMail = function(body) {
    return functions/* fetcherNext.post */.mj.post("/mail?user=guest", body);
};


/***/ }),

/***/ 3955:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 1082:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 4853:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ esm; }
});

// UNUSED EXPORTS: ReCAPTCHA

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(5697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha.js
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var ReCAPTCHA =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ReCAPTCHA, _React$Component);

  function ReCAPTCHA() {
    var _this;

    _this = _React$Component.call(this) || this;
    _this.handleExpired = _this.handleExpired.bind(_assertThisInitialized(_this));
    _this.handleErrored = _this.handleErrored.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleRecaptchaRef = _this.handleRecaptchaRef.bind(_assertThisInitialized(_this));
    return _this;
  }

  var _proto = ReCAPTCHA.prototype;

  _proto.getValue = function getValue() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this.props.grecaptcha.getResponse(this._widgetId);
    }

    return null;
  };

  _proto.getWidgetId = function getWidgetId() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      return this._widgetId;
    }

    return null;
  };

  _proto.execute = function execute() {
    var grecaptcha = this.props.grecaptcha;

    if (grecaptcha && this._widgetId !== undefined) {
      return grecaptcha.execute(this._widgetId);
    } else {
      this._executeRequested = true;
    }
  };

  _proto.executeAsync = function executeAsync() {
    var _this2 = this;

    return new Promise(function (resolve, reject) {
      _this2.executionResolve = resolve;
      _this2.executionReject = reject;

      _this2.execute();
    });
  };

  _proto.reset = function reset() {
    if (this.props.grecaptcha && this._widgetId !== undefined) {
      this.props.grecaptcha.reset(this._widgetId);
    }
  };

  _proto.handleExpired = function handleExpired() {
    if (this.props.onExpired) {
      this.props.onExpired();
    } else {
      this.handleChange(null);
    }
  };

  _proto.handleErrored = function handleErrored() {
    if (this.props.onErrored) {
      this.props.onErrored();
    }

    if (this.executionReject) {
      this.executionReject();
      delete this.executionResolve;
      delete this.executionReject;
    }
  };

  _proto.handleChange = function handleChange(token) {
    if (this.props.onChange) {
      this.props.onChange(token);
    }

    if (this.executionResolve) {
      this.executionResolve(token);
      delete this.executionReject;
      delete this.executionResolve;
    }
  };

  _proto.explicitRender = function explicitRender() {
    if (this.props.grecaptcha && this.props.grecaptcha.render && this._widgetId === undefined) {
      var wrapper = document.createElement("div");
      this._widgetId = this.props.grecaptcha.render(wrapper, {
        sitekey: this.props.sitekey,
        callback: this.handleChange,
        theme: this.props.theme,
        type: this.props.type,
        tabindex: this.props.tabindex,
        "expired-callback": this.handleExpired,
        "error-callback": this.handleErrored,
        size: this.props.size,
        stoken: this.props.stoken,
        hl: this.props.hl,
        badge: this.props.badge
      });
      this.captcha.appendChild(wrapper);
    }

    if (this._executeRequested && this.props.grecaptcha && this._widgetId !== undefined) {
      this._executeRequested = false;
      this.execute();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    this.explicitRender();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.explicitRender();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._widgetId !== undefined) {
      this.delayOfCaptchaIframeRemoving();
      this.reset();
    }
  };

  _proto.delayOfCaptchaIframeRemoving = function delayOfCaptchaIframeRemoving() {
    var temporaryNode = document.createElement("div");
    document.body.appendChild(temporaryNode);
    temporaryNode.style.display = "none"; // move of the recaptcha to a temporary node

    while (this.captcha.firstChild) {
      temporaryNode.appendChild(this.captcha.firstChild);
    } // delete the temporary node after reset will be done


    setTimeout(function () {
      document.body.removeChild(temporaryNode);
    }, 5000);
  };

  _proto.handleRecaptchaRef = function handleRecaptchaRef(elem) {
    this.captcha = elem;
  };

  _proto.render = function render() {
    // consume properties owned by the reCATPCHA, pass the rest to the div so the user can style it.

    /* eslint-disable no-unused-vars */
    var _this$props = this.props,
        sitekey = _this$props.sitekey,
        onChange = _this$props.onChange,
        theme = _this$props.theme,
        type = _this$props.type,
        tabindex = _this$props.tabindex,
        onExpired = _this$props.onExpired,
        onErrored = _this$props.onErrored,
        size = _this$props.size,
        stoken = _this$props.stoken,
        grecaptcha = _this$props.grecaptcha,
        badge = _this$props.badge,
        hl = _this$props.hl,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["sitekey", "onChange", "theme", "type", "tabindex", "onExpired", "onErrored", "size", "stoken", "grecaptcha", "badge", "hl"]);
    /* eslint-enable no-unused-vars */


    return react.createElement("div", _extends({}, childProps, {
      ref: this.handleRecaptchaRef
    }));
  };

  return ReCAPTCHA;
}(react.Component);


ReCAPTCHA.displayName = "ReCAPTCHA";
ReCAPTCHA.propTypes = {
  sitekey: (prop_types_default()).string.isRequired,
  onChange: (prop_types_default()).func,
  grecaptcha: (prop_types_default()).object,
  theme: prop_types_default().oneOf(["dark", "light"]),
  type: prop_types_default().oneOf(["image", "audio"]),
  tabindex: (prop_types_default()).number,
  onExpired: (prop_types_default()).func,
  onErrored: (prop_types_default()).func,
  size: prop_types_default().oneOf(["compact", "normal", "invisible"]),
  stoken: (prop_types_default()).string,
  hl: (prop_types_default()).string,
  badge: prop_types_default().oneOf(["bottomright", "bottomleft", "inline"])
};
ReCAPTCHA.defaultProps = {
  onChange: function onChange() {},
  theme: "light",
  type: "image",
  tabindex: 0,
  size: "normal",
  badge: "bottomright"
};
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
;// CONCATENATED MODULE: ./node_modules/react-async-script/lib/esm/async-script-loader.js
function async_script_loader_extends() { async_script_loader_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return async_script_loader_extends.apply(this, arguments); }

function async_script_loader_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function async_script_loader_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var SCRIPT_MAP = {}; // A counter used to generate a unique id for each component that uses the function

var idCount = 0;
function makeAsyncScript(getScriptURL, options) {
  options = options || {};
  return function wrapWithAsyncScript(WrappedComponent) {
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";

    var AsyncScriptLoader =
    /*#__PURE__*/
    function (_Component) {
      async_script_loader_inheritsLoose(AsyncScriptLoader, _Component);

      function AsyncScriptLoader(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.state = {};
        _this.__scriptURL = "";
        return _this;
      }

      var _proto = AsyncScriptLoader.prototype;

      _proto.asyncScriptLoaderGetScriptLoaderID = function asyncScriptLoaderGetScriptLoaderID() {
        if (!this.__scriptLoaderID) {
          this.__scriptLoaderID = "async-script-loader-" + idCount++;
        }

        return this.__scriptLoaderID;
      };

      _proto.setupScriptURL = function setupScriptURL() {
        this.__scriptURL = typeof getScriptURL === "function" ? getScriptURL() : getScriptURL;
        return this.__scriptURL;
      };

      _proto.asyncScriptLoaderHandleLoad = function asyncScriptLoaderHandleLoad(state) {
        var _this2 = this;

        // use reacts setState callback to fire props.asyncScriptOnLoad with new state/entry
        this.setState(state, function () {
          return _this2.props.asyncScriptOnLoad && _this2.props.asyncScriptOnLoad(_this2.state);
        });
      };

      _proto.asyncScriptLoaderTriggerOnScriptLoaded = function asyncScriptLoaderTriggerOnScriptLoaded() {
        var mapEntry = SCRIPT_MAP[this.__scriptURL];

        if (!mapEntry || !mapEntry.loaded) {
          throw new Error("Script is not loaded.");
        }

        for (var obsKey in mapEntry.observers) {
          mapEntry.observers[obsKey](mapEntry);
        }

        delete window[options.callbackName];
      };

      _proto.componentDidMount = function componentDidMount() {
        var _this3 = this;

        var scriptURL = this.setupScriptURL();
        var key = this.asyncScriptLoaderGetScriptLoaderID();
        var _options = options,
            globalName = _options.globalName,
            callbackName = _options.callbackName,
            scriptId = _options.scriptId; // check if global object already attached to window

        if (globalName && typeof window[globalName] !== "undefined") {
          SCRIPT_MAP[scriptURL] = {
            loaded: true,
            observers: {}
          };
        } // check if script loading already


        if (SCRIPT_MAP[scriptURL]) {
          var entry = SCRIPT_MAP[scriptURL]; // if loaded or errored then "finish"

          if (entry && (entry.loaded || entry.errored)) {
            this.asyncScriptLoaderHandleLoad(entry);
            return;
          } // if still loading then callback to observer queue


          entry.observers[key] = function (entry) {
            return _this3.asyncScriptLoaderHandleLoad(entry);
          };

          return;
        }
        /*
         * hasn't started loading
         * start the "magic"
         * setup script to load and observers
         */


        var observers = {};

        observers[key] = function (entry) {
          return _this3.asyncScriptLoaderHandleLoad(entry);
        };

        SCRIPT_MAP[scriptURL] = {
          loaded: false,
          observers: observers
        };
        var script = document.createElement("script");
        script.src = scriptURL;
        script.async = true;

        for (var attribute in options.attributes) {
          script.setAttribute(attribute, options.attributes[attribute]);
        }

        if (scriptId) {
          script.id = scriptId;
        }

        var callObserverFuncAndRemoveObserver = function callObserverFuncAndRemoveObserver(func) {
          if (SCRIPT_MAP[scriptURL]) {
            var mapEntry = SCRIPT_MAP[scriptURL];
            var observersMap = mapEntry.observers;

            for (var obsKey in observersMap) {
              if (func(observersMap[obsKey])) {
                delete observersMap[obsKey];
              }
            }
          }
        };

        if (callbackName && typeof window !== "undefined") {
          window[callbackName] = function () {
            return _this3.asyncScriptLoaderTriggerOnScriptLoaded();
          };
        }

        script.onload = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.loaded = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              if (callbackName) {
                return false;
              }

              observer(mapEntry);
              return true;
            });
          }
        };

        script.onerror = function () {
          var mapEntry = SCRIPT_MAP[scriptURL];

          if (mapEntry) {
            mapEntry.errored = true;
            callObserverFuncAndRemoveObserver(function (observer) {
              observer(mapEntry);
              return true;
            });
          }
        };

        document.body.appendChild(script);
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        // Remove tag script
        var scriptURL = this.__scriptURL;

        if (options.removeOnUnmount === true) {
          var allScripts = document.getElementsByTagName("script");

          for (var i = 0; i < allScripts.length; i += 1) {
            if (allScripts[i].src.indexOf(scriptURL) > -1) {
              if (allScripts[i].parentNode) {
                allScripts[i].parentNode.removeChild(allScripts[i]);
              }
            }
          }
        } // Clean the observer entry


        var mapEntry = SCRIPT_MAP[scriptURL];

        if (mapEntry) {
          delete mapEntry.observers[this.asyncScriptLoaderGetScriptLoaderID()];

          if (options.removeOnUnmount === true) {
            delete SCRIPT_MAP[scriptURL];
          }
        }
      };

      _proto.render = function render() {
        var globalName = options.globalName; // remove asyncScriptOnLoad from childProps

        var _this$props = this.props,
            asyncScriptOnLoad = _this$props.asyncScriptOnLoad,
            forwardedRef = _this$props.forwardedRef,
            childProps = async_script_loader_objectWithoutPropertiesLoose(_this$props, ["asyncScriptOnLoad", "forwardedRef"]); // eslint-disable-line no-unused-vars


        if (globalName && typeof window !== "undefined") {
          childProps[globalName] = typeof window[globalName] !== "undefined" ? window[globalName] : undefined;
        }

        childProps.ref = forwardedRef;
        return (0,react.createElement)(WrappedComponent, childProps);
      };

      return AsyncScriptLoader;
    }(react.Component); // Note the second param "ref" provided by React.forwardRef.
    // We can pass it along to AsyncScriptLoader as a regular prop, e.g. "forwardedRef"
    // And it can then be attached to the Component.


    var ForwardedComponent = (0,react.forwardRef)(function (props, ref) {
      return (0,react.createElement)(AsyncScriptLoader, async_script_loader_extends({}, props, {
        forwardedRef: ref
      }));
    });
    ForwardedComponent.displayName = "AsyncScriptLoader(" + wrappedComponentName + ")";
    ForwardedComponent.propTypes = {
      asyncScriptOnLoad: (prop_types_default()).func
    };
    return hoist_non_react_statics_cjs_default()(ForwardedComponent, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/recaptcha-wrapper.js


var callbackName = "onloadcallback";
var globalName = "grecaptcha";

function getOptions() {
  return typeof window !== "undefined" && window.recaptchaOptions || {};
}

function getURL() {
  var dynamicOptions = getOptions();
  var hostname = dynamicOptions.useRecaptchaNet ? "recaptcha.net" : "www.google.com";
  return "https://" + hostname + "/recaptcha/api.js?onload=" + callbackName + "&render=explicit";
}

/* harmony default export */ var recaptcha_wrapper = (makeAsyncScript(getURL, {
  callbackName: callbackName,
  globalName: globalName
})(ReCAPTCHA));
;// CONCATENATED MODULE: ./node_modules/react-google-recaptcha/lib/esm/index.js


/* harmony default export */ var esm = (recaptcha_wrapper);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5445,5525,4939,8078,9774,2888,179], function() { return __webpack_exec__(4549); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);